import { render, staticRenderFns } from "./NotifyAllActiveUsers.vue?vue&type=template&id=3f25d678&"
import script from "./NotifyAllActiveUsers.vue?vue&type=script&lang=js&"
export * from "./NotifyAllActiveUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports